import React from 'react';
import {string, func} from 'prop-types';
import {Form} from 'semantic-ui-react';

/*
    "Link (URL)" tab: a plain text field for an image URL. The parent modal
    (ImageUploadModal) offers an optional crop step for this source too --
    clicking Crop fetches the URL through admin-api's GET /image/fetch
    (§6's RemoteImageFetcher) and hands the result to ImageCropStep as a
    same-origin File, the same as a device upload. That fetch/invalidation
    logic lives in ImageUploadModal, not here; this component only owns the
    URL text field itself.
*/
const ImageUploadLinkTab = (props) => (
  <Form>
    <Form.Field>
      <label>Image URL</label>
      <input
        type="text"
        placeholder="https://example.com/image.jpg"
        value={props.value}
        onChange={(event) => props.onChange(event.target.value)} />
    </Form.Field>
  </Form>
);

ImageUploadLinkTab.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired
};

export default ImageUploadLinkTab;



// WEBPACK FOOTER //
// ./public/components/images/ImageUploadLinkTab.jsx